import React, {Component} from 'react';
import axios from 'axios';
import {toast} from 'react-toastify';

const $ = window.$;

export default class ModalDeletePackage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            cPackage: null,
            loading: false
        }

        this.deletePackage = this.deletePackage.bind(this);
    }

    componentWillReceiveProps(props) {
        this.setState({
            cPackage : props.cPackage
        })
    }

    deletePackage() {
        this.setState({
            loading: true
        });

        axios.post(global.config.apiDomain + '/rest/packages/delete', JSON.stringify(this.state.cPackage), {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(res => {
            this.setState({
                loading: false
            });

            $("#modalDeletePackage").modal("hide");
            toast.success('Xóa thành công'); 
            this.props.resetList();
        })
    }

    render() {

        const {cPackage} = this.state;

        return (
            <div>
                <div className="modal fade" id="modalDeletePackage" tabIndex={-1} role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog  modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">Xóa Package</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            {cPackage ? (
                                <div className="modal-body">
                                <h3 className="text-center text-danger">Bạn chắc chắn muốn xóa <span className="font-weight-bold">{cPackage.packageName}</span> ?</h3>
                            </div>
                            ) : ""}
                            <div className="modal-footer">
                                <button type="button" className="btn btn-red" data-dismiss="modal">Hủy</button>
                                {this.state.loading ? 
                                (
                                <button style={{width: "120px"}} className="btn btn-red" type="button" disabled>
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    Xác nhận...
                                </button>
                                ) :
                                (
                                <button 
                                    style={{width: "120px"}} 
                                    type="button" 
                                    className="btn btn-red"
                                    onClick={this.deletePackage}>Xóa</button>    
                                )}                        
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}